import { __decorate, __param } from 'tslib';
import { ElementRef, Inject, HostBinding, Component, ChangeDetectionStrategy, ɵɵdefineInjectable, ɵɵinject, Injectable, NgModule } from '@angular/core';
import { isNumber, TuiDestroyService, tuiPure, AbstractTuiDialogService, TuiIdService, TUI_ALERTS } from '@taiga-ui/cdk';
import { tuiFadeIn, tuiSlideInRight, tuiHeightCollapse } from '@taiga-ui/core/animations';
import { TUI_NOTIFICATION_OPTIONS, TUI_ANIMATION_OPTIONS } from '@taiga-ui/core/tokens';
import { POLYMORPHEUS_CONTEXT, PolymorpheusComponent, PolymorpheusModule } from '@tinkoff/ng-polymorpheus';
import { timer, fromEvent } from 'rxjs';
import { takeUntil, repeatWhen } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { TuiNotificationModule } from '@taiga-ui/core/components/notification';
import { TuiIdService as TuiIdService$1 } from '@taiga-ui/cdk/services';

// TODO: Refactor according to new context by 3.0 and get rid of $any in template
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@taiga-ui/core/components/notification';
import * as ɵngcc3 from '@tinkoff/ng-polymorpheus';
import * as ɵngcc4 from '@taiga-ui/cdk';

function TuiAlertComponent_tui_notification_0_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "label", 5);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("content", ctx_r3.item.label)("context", ctx_r3.context);
} }
function TuiAlertComponent_tui_notification_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tui-notification", 2);
    ɵngcc0.ɵɵlistener("close", function TuiAlertComponent_tui_notification_0_Template_tui_notification_close_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.closeNotification(); });
    ɵngcc0.ɵɵtemplate(1, TuiAlertComponent_tui_notification_0_label_1_Template, 1, 2, "label", 3);
    ɵngcc0.ɵɵelement(2, "div", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("status", ctx_r0.item.status)("hasIcon", ctx_r0.item.hasIcon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.item.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("content", ctx_r0.item.content)("context", ctx_r0.context);
} }
function TuiAlertComponent_ng_template_1_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "label", 5);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("content", ctx_r6.item.label)("context", ctx_r6.context);
} }
function TuiAlertComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tui-notification", 6);
    ɵngcc0.ɵɵtemplate(1, TuiAlertComponent_ng_template_1_label_1_Template, 1, 2, "label", 3);
    ɵngcc0.ɵɵelement(2, "div", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("status", ctx_r2.item.status)("hasIcon", ctx_r2.item.hasIcon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.item.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("content", ctx_r2.item.content)("context", ctx_r2.context);
} }
let TuiAlertComponent = class TuiAlertComponent {
    constructor(elementRef, destroy$, options, animationOptions, item) {
        this.elementRef = elementRef;
        this.destroy$ = destroy$;
        this.options = options;
        this.animationOptions = animationOptions;
        this.item = item;
        this.autoClose = typeof this.item.autoClose === 'function'
            ? this.item.autoClose(this.item.status)
            : this.item.autoClose;
        this.animation = Object.assign({ value: '' }, this.animationOptions);
    }
    ngOnInit() {
        this.initAutoClose();
    }
    get context() {
        return this.calculateContext(this.item);
    }
    closeNotification() {
        this.item.$implicit.complete();
    }
    calculateContext({ $implicit, status, data, label, }) {
        return {
            $implicit: status,
            data,
            label,
            closeHook: () => {
                $implicit.complete();
            },
            emitHook: (data) => {
                $implicit.next(data);
            },
            emitAndCloseHook: (data) => {
                $implicit.next(data);
                $implicit.complete();
            },
        };
    }
    initAutoClose() {
        if (!this.autoClose) {
            return;
        }
        timer(isNumber(this.autoClose) ? this.autoClose : this.options.defaultAutoCloseTime)
            .pipe(takeUntil(fromEvent(this.elementRef.nativeElement, 'mouseenter')), 
        // eslint-disable-next-line rxjs/no-ignored-notifier
        repeatWhen(() => fromEvent(this.elementRef.nativeElement, 'mouseleave')), takeUntil(this.destroy$))
            .subscribe(() => this.closeNotification());
    }
};
TuiAlertComponent.ɵfac = function TuiAlertComponent_Factory(t) { return new (t || TuiAlertComponent)(ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(TuiDestroyService), ɵngcc0.ɵɵdirectiveInject(TUI_NOTIFICATION_OPTIONS), ɵngcc0.ɵɵdirectiveInject(TUI_ANIMATION_OPTIONS), ɵngcc0.ɵɵdirectiveInject(POLYMORPHEUS_CONTEXT)); };
TuiAlertComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiAlertComponent, selectors: [["tui-alert"]], hostAttrs: ["role", "alert"], hostVars: 3, hostBindings: function TuiAlertComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵsyntheticHostProperty("@tuiFadeIn", ctx.animation)("@tuiSlideInRight", ctx.animation)("@tuiHeightCollapse", ctx.animation);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([TuiDestroyService])], decls: 3, vars: 2, consts: [[3, "status", "hasIcon", "close", 4, "ngIf", "ngIfElse"], ["noClose", ""], [3, "status", "hasIcon", "close"], ["polymorpheus-outlet", "", "automation-id", "tui-notification-alert__heading", "class", "heading", 3, "content", "context", 4, "ngIf"], ["polymorpheus-outlet", "", "automation-id", "tui-notification-alert__content", 1, "content", 3, "content", "context"], ["polymorpheus-outlet", "", "automation-id", "tui-notification-alert__heading", 1, "heading", 3, "content", "context"], [3, "status", "hasIcon"]], template: function TuiAlertComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TuiAlertComponent_tui_notification_0_Template, 3, 5, "tui-notification", 0);
        ɵngcc0.ɵɵtemplate(1, TuiAlertComponent_ng_template_1_Template, 3, 5, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.item.hasCloseButton)("ngIfElse", _r1);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.TuiNotificationComponent, ɵngcc3.PolymorpheusOutletComponent], styles: ["[_nghost-%COMP%]{box-shadow:0 .5rem 1rem rgba(0,0,0,.16);display:block;border-radius:var(--tui-radius-m);width:18rem;margin:2rem 3rem 0 auto}tui-root._mobile   [_nghost-%COMP%]{margin:1rem 1rem 0 auto}[_nghost-%COMP%]:not(:first-child){margin-top:.75rem}@media screen and (min-width:80em){[_nghost-%COMP%]{width:23rem}}.heading[_ngcontent-%COMP%]{font:var(--tui-font-text-m);line-height:1.25rem;font-weight:700;margin:0}.content[_ngcontent-%COMP%]{color:var(--tui-text-01);word-wrap:break-word}.content[_ngcontent-%COMP%]:empty{display:none}"], data: { animation: [tuiFadeIn, tuiSlideInRight, tuiHeightCollapse] }, changeDetection: 0 });
TuiAlertComponent.ctorParameters = () => [
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: TuiDestroyService, decorators: [{ type: Inject, args: [TuiDestroyService,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_NOTIFICATION_OPTIONS,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_ANIMATION_OPTIONS,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [POLYMORPHEUS_CONTEXT,] }] }
];
__decorate([
    HostBinding('@tuiFadeIn'),
    HostBinding('@tuiSlideInRight'),
    HostBinding('@tuiHeightCollapse')
], TuiAlertComponent.prototype, "animation", void 0);
__decorate([
    tuiPure
], TuiAlertComponent.prototype, "calculateContext", null);
TuiAlertComponent = __decorate([ __param(0, Inject(ElementRef)),
    __param(1, Inject(TuiDestroyService)),
    __param(2, Inject(TUI_NOTIFICATION_OPTIONS)),
    __param(3, Inject(TUI_ANIMATION_OPTIONS)),
    __param(4, Inject(POLYMORPHEUS_CONTEXT))
], TuiAlertComponent);

let TuiAlertService = class TuiAlertService extends AbstractTuiDialogService {
    constructor(defaultOptions, idService) {
        super(idService);
        this.defaultOptions = defaultOptions;
        this.component = new PolymorpheusComponent(TuiAlertComponent);
    }
};
TuiAlertService.ɵfac = function TuiAlertService_Factory(t) { return new (t || TuiAlertService)(ɵngcc0.ɵɵinject(TUI_NOTIFICATION_OPTIONS), ɵngcc0.ɵɵinject(TuiIdService)); };
TuiAlertService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [TUI_NOTIFICATION_OPTIONS,] }] },
    { type: TuiIdService, decorators: [{ type: Inject, args: [TuiIdService,] }] }
];
TuiAlertService.ɵprov = ɵɵdefineInjectable({ factory: function TuiAlertService_Factory() { return new TuiAlertService(ɵɵinject(TUI_NOTIFICATION_OPTIONS), ɵɵinject(TuiIdService$1)); }, token: TuiAlertService, providedIn: "root" });
TuiAlertService = __decorate([ __param(0, Inject(TUI_NOTIFICATION_OPTIONS)),
    __param(1, Inject(TuiIdService))
], TuiAlertService);
/** @deprecated use {@link TuiAlertService} */
let TuiNotificationsService = class TuiNotificationsService {
    constructor(alert) {
        this.alert = alert;
    }
    show(content, options = {}) {
        // @ts-ignore
        return this.alert.open(content, options);
    }
};
TuiNotificationsService.ɵfac = function TuiNotificationsService_Factory(t) { return new (t || TuiNotificationsService)(ɵngcc0.ɵɵinject(TuiAlertService)); };
TuiNotificationsService.ctorParameters = () => [
    { type: TuiAlertService, decorators: [{ type: Inject, args: [TuiAlertService,] }] }
];
TuiNotificationsService.ɵprov = ɵɵdefineInjectable({ factory: function TuiNotificationsService_Factory() { return new TuiNotificationsService(ɵɵinject(TuiAlertService)); }, token: TuiNotificationsService, providedIn: "root" });
TuiNotificationsService = __decorate([ __param(0, Inject(TuiAlertService))
], TuiNotificationsService);

let TuiAlertModule = class TuiAlertModule {
};
TuiAlertModule.ɵfac = function TuiAlertModule_Factory(t) { return new (t || TuiAlertModule)(); };
TuiAlertModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiAlertModule });
TuiAlertModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        {
            provide: TUI_ALERTS,
            useExisting: TuiAlertService,
            multi: true
        },
    ], imports: [[CommonModule, PolymorpheusModule, TuiNotificationModule]] });
/** @deprecated use {@link TuiAlertModule} */
let TuiNotificationsModule = class TuiNotificationsModule {
};
TuiNotificationsModule.ɵfac = function TuiNotificationsModule_Factory(t) { return new (t || TuiNotificationsModule)(); };
TuiNotificationsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiNotificationsModule });
TuiNotificationsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[TuiAlertModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiAlertComponent, [{
        type: Component,
        args: [{
                selector: 'tui-alert',
                template: "<tui-notification\n    *ngIf=\"item.hasCloseButton; else noClose\"\n    [status]=\"item.status\"\n    [hasIcon]=\"item.hasIcon\"\n    (close)=\"closeNotification()\"\n>\n    <label\n        *ngIf=\"item.label\"\n        polymorpheus-outlet\n        automation-id=\"tui-notification-alert__heading\"\n        class=\"heading\"\n        [content]=\"$any(item.label)\"\n        [context]=\"context\"\n    ></label>\n    <div\n        polymorpheus-outlet\n        automation-id=\"tui-notification-alert__content\"\n        class=\"content\"\n        [content]=\"item.content\"\n        [context]=\"$any(context)\"\n    ></div>\n</tui-notification>\n<ng-template #noClose>\n    <tui-notification\n        [status]=\"item.status\"\n        [hasIcon]=\"item.hasIcon\"\n    >\n        <label\n            *ngIf=\"item.label\"\n            polymorpheus-outlet\n            automation-id=\"tui-notification-alert__heading\"\n            class=\"heading\"\n            [content]=\"$any(item.label)\"\n            [context]=\"context\"\n        ></label>\n        <div\n            polymorpheus-outlet\n            automation-id=\"tui-notification-alert__content\"\n            class=\"content\"\n            [content]=\"item.content\"\n            [context]=\"$any(context)\"\n        ></div>\n    </tui-notification>\n</ng-template>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [TuiDestroyService],
                animations: [tuiFadeIn, tuiSlideInRight, tuiHeightCollapse],
                host: { role: 'alert' },
                styles: [":host{box-shadow:0 .5rem 1rem rgba(0,0,0,.16);display:block;border-radius:var(--tui-radius-m);width:18rem;margin:2rem 3rem 0 auto}:host-context(tui-root._mobile) :host{margin:1rem 1rem 0 auto}:host:not(:first-child){margin-top:.75rem}@media screen and (min-width:80em){:host{width:23rem}}.heading{font:var(--tui-font-text-m);line-height:1.25rem;font-weight:700;margin:0}.content{color:var(--tui-text-01);word-wrap:break-word}.content:empty{display:none}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: ɵngcc4.TuiDestroyService, decorators: [{
                type: Inject,
                args: [TuiDestroyService]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_NOTIFICATION_OPTIONS]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_ANIMATION_OPTIONS]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [POLYMORPHEUS_CONTEXT]
            }] }]; }, { animation: [{
            type: HostBinding,
            args: ['@tuiFadeIn']
        }, {
            type: HostBinding,
            args: ['@tuiSlideInRight']
        }, {
            type: HostBinding,
            args: ['@tuiHeightCollapse']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiAlertService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [TUI_NOTIFICATION_OPTIONS]
            }] }, { type: ɵngcc4.TuiIdService, decorators: [{
                type: Inject,
                args: [TuiIdService]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiNotificationsService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: TuiAlertService, decorators: [{
                type: Inject,
                args: [TuiAlertService]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiAlertModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, PolymorpheusModule, TuiNotificationModule],
                declarations: [TuiAlertComponent],
                exports: [TuiAlertComponent],
                entryComponents: [TuiAlertComponent],
                providers: [
                    {
                        provide: TUI_ALERTS,
                        useExisting: TuiAlertService,
                        multi: true
                    },
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiAlertModule, { declarations: function () { return [TuiAlertComponent]; }, imports: function () { return [CommonModule, PolymorpheusModule, TuiNotificationModule]; }, exports: function () { return [TuiAlertComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiNotificationsModule, [{
        type: NgModule,
        args: [{ imports: [TuiAlertModule] }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiNotificationsModule, { imports: [TuiAlertModule] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiAlertComponent, TuiAlertModule, TuiAlertService, TuiNotificationsModule, TuiNotificationsService };

